import React from "react";
import Fade from "react-reveal/Fade";

const Landing = () => {
  return (
    <Fade>
      <div id="landing" className="section landing">
        {/* <img className="w-100" src="./assets/imgs/bg-hero.png" alt="bg-hero" /> */}
        <img className="w-100" src="./assets/imgs/12.png" alt="bg-hero" />
      </div>
    </Fade>
  );
};

export default Landing;
